import React from 'react';

import LoadingBar from '../../components/LoadingBar/LoadingBar';
import { Spinner } from '../../components/Spinner';

interface BlankLoadingPageProps {
  /** What is being waited on, in the seller's terms. */
  message?: string;
}

/**
 * A whole screen given over to waiting — between sign-in and the app, or while
 * an invitation is checked.
 *
 * A line of 20px text alone on a page reads as a broken render rather than
 * work in progress; the bar at the top and a spinner beside the message say
 * something is happening.
 */
export const BlankLoadingPage: React.FC<BlankLoadingPageProps> = ({ message = 'Loading…' }) => (
  <>
    <LoadingBar />
    <div className="flex h-screen items-center justify-center bg-surface px-4">
      <div className="flex items-center gap-3" role="status">
        <Spinner size="small" />
        <p className="text-sm font-medium text-muted-foreground">{message}</p>
      </div>
    </div>
  </>
);
